import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-end',
  templateUrl: './end.component.html',
  styleUrls: ['./end.component.css']
})
export class EndComponent implements OnInit {

  currentClasses = {};
  score;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getScore();
    this.setBodyClasses();
    this.startTimeOut();
  }

  getScore(): void {
    this.score = this.route.snapshot.paramMap.get('score');
  }

  setBodyClasses() {
    this.currentClasses =  {
      'bodyWin': this.score>=3,
      'bodyLost': this.score<3
    };
  }

  startTimeOut(){
    setTimeout(()=>{
      this.router.navigate(['home']);
    }, 30000);
  }
}
